import { staticContentAxios } from '../../configuration/axiosConfig';
import { ClientResponse } from '../../../model/ClientResponse';

// eslint-disable-next-line import/prefer-default-export
export const getChronologickyRegisterZakonovRocnikHtmlContent = async (year: string|undefined):
  Promise<ClientResponse<string>> => {
  const {
    data, status,
  } = await staticContentAxios.get(
    `static/SK/ZZ/${year}/index.portal`,
  );

  return {
    data,
    responseCode: status,
  };
};
